import { styled } from '@mui/material/styles';

const StyledStepLabel = styled('div')`
  font-size: 1.125rem;
  font-weight: bold;
  color: var(--step-label-color);
  text-transform: uppercase;
`;

export default StyledStepLabel;
